import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  UpsertPromptMutation,
  UpsertPromptMutationVariables,
} from '#graphql/generated';

export const UPSERT_PROMPT: TypedDocumentNode<
  UpsertPromptMutation,
  UpsertPromptMutationVariables
> = gql`
  mutation UpsertPrompt($input: UpsertPromptInput!) {
    upsertPrompt(input: $input) {
      message
      promptDefinition {
        id
        value
        createdAt
        updatedAt
      }
    }
  }
`;
